import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

const MenuItemLandingUI = (props) => (
  <MenuItem {...props}>
    { props.children }
  </MenuItem>
);

export default MenuItemLandingUI;